module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: "bor",
    attrs: {
      "alt": "Image",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box_1"
  }, [_c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Sherman III of HQ, 8th Armoured Brigade, drives clear of a landing craft on 10 June 1944. The brigade's colourful Fox Face formation badge with the combined AoS sign of a white 993 on a red square, incorporating the 2 inch white bar identifying army troops, has been painted onto the transmission coverto the right of the tank's name.")]), _vm._v(" Virgin.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4947b0bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Front.vue
// module id = 66
// module chunks = 0